export class AbortListAlreadyAbortedError extends Error {
  constructor() {
    super('Abort list has already been aborted');
  }
}

export class AbortList {
  #abortControllers: AbortController[] = [];

  #aborted: Error | boolean = false;

  newSignal(): AbortSignal {
    if (this.#aborted instanceof Error) {
      throw this.#aborted;
    }
    if (this.#aborted) {
      throw new AbortListAlreadyAbortedError();
    }
    const abortController = new AbortController();
    this.#abortControllers.push(abortController);
    return abortController.signal;
  }

  abort(reason?: Error): void {
    this.#aborted = reason ?? true;
    for (const abortController of this.#abortControllers) {
      abortController.abort(reason);
    }
  }
}
